import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const addMenbersInSegment = "/marcom/segment/addMember";
const remove = "/marcom/segment/removeMember";
const getAll = "/marcom/segment/getAll";
const getAllSegmentUser = "/marcom/segment/getAllSegmentUser";
const add = "/marcom/segment/create";
const deleteSegment = "/marcom/segment/delete";

export default {
  addMembersInSegment(payload) {
    return Repository.post(`${addMenbersInSegment}`, payload);
  },

  add(payload) {
    return Repository.post(`${add}`, payload);
  },
  deleteSegment(payload) {
    return Repository.post(`${deleteSegment}`, payload);
  },
  removeMember(payload) {
    return Repository.post(`${remove}`, payload);
  },
  getAllSegment(payload) {
    return Repository.post(`${getAll}`, payload);
  },
  getAllSegmentUser(payload) {
    return Repository.post(`${getAllSegmentUser}`, payload);
  },
};
